import React from 'react';
import { Input } from '@shared/components';
import { useDraftValue } from '@shared/hooks/useDraftValue';
import type { SageRowDrafts } from '../../hooks/useSageMappingRowEditor';
import { sageDraftInputId } from '../../utils/sageMappingRows';

export type SageDraftField = 'code' | 'name' | 'date';

interface Props {
    field: SageDraftField;
    rowKey: string;
    subject: string;
    drafts: SageRowDrafts;
    disabled?: boolean;
    autoFocus?: boolean;
}

const FIELD_LABEL: Record<SageDraftField, string> = {
    code: 'Account code',
    name: 'Account name',
    date: 'Effective from',
};

export const SageNominalDraftInput: React.FC<Props> = ({ field, rowKey, subject, drafts, disabled, autoFocus }) => {
    const [value, setValue] = useDraftValue(drafts[field]);
    return (
        <Input
            id={sageDraftInputId(field, rowKey)}
            type={field === 'date' ? 'date' : 'text'}
            value={value}
            aria-label={`${FIELD_LABEL[field]} for ${subject}`}
            autoFocus={autoFocus}
            disabled={disabled}
            onChange={(event) => setValue(event.target.value)}
            className={field === 'name' ? 'w-56' : 'w-40'}
        />
    );
};
